import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ApproveApplicationRequest } from '@nucleus-commerce/api-client/platform';

import { organizationKeys } from '@/features/organizations';

import { applicationsApi } from '../api/applications-api';

import { applicationKeys } from './application-keys';

/**
 * Provisions the organization, its store and the invited owner in one call. A taken slug comes
 * back as a field error the dialog shows; anything else is toasted.
 */
export function useApproveApplication(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: ApproveApplicationRequest) => applicationsApi.approve(id, body),
    meta: { successMessage: 'applications:toasts.approved' },
    onSuccess: (result) => {
      queryClient.setQueryData(applicationKeys.detail(id), result.application);
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: applicationKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: applicationKeys.counts() }),
        queryClient.invalidateQueries({ queryKey: organizationKeys.lists() }),
      ]);
    },
  });
}
